import React from "react";

import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Modal } from "./Modal";
// Your trigger render function must accept these props
export type TriggerProps = {
  onClick: (arg0: Event) => void;
  disabled: boolean;
};
// Your modal render function must accept these props
export type ModalProps = {
  show: boolean;
  onHide: () => void;
};
type Props = {
  trigger: (arg0: TriggerProps) => React.ReactNode;
  modal?: (arg0: ModalProps) => React.ReactNode;
  children?: React.ReactNode;
  startEnabled?: boolean;
  // whether or not the modal starts enabled
  runOnOpen?: () => void;
  // runs function when modal is clicked on
  runOnHide?: () => void;
  // runs function when modal is hidden
  disabled: boolean;
};
type State = {
  shown: boolean;
};
// A StandaloneTrigger is a simple to use trigger for a modal. The modal is
// controlled by its own close button and by the rendered trigger.
//
// You can pass a modal function which will be passed an onHide method and
// should be used to hide the modal, or you can just include the modal dialog as
// children.
export class StandaloneTrigger extends React.Component<Props, State> {
  static defaultProps = {
    disabled: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      shown: this.props.startEnabled || false,
    };
  }

  handleTriggerClick = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      if (e.target.baseURI !== null) {
        const location = typeof e.target.baseURI === "string" ? e.target.baseURI.split("/") : [];
        AnalyticsTracking.trackEvent("cta_clicked", {
          location: location[location.length - 1].replace("-", "_"),
          label: e.target instanceof HTMLInputElement && e.target.innerText,
        });
      }
    }

    e.preventDefault();
    if (this.props.runOnOpen) this.props.runOnOpen();
    this.setState({
      shown: true,
    });
  };

  handleModalHide = () => {
    if (this.props.runOnHide) this.props.runOnHide();
    this.setState({
      shown: false,
    });
  };

  render() {
    const { trigger, modal, children, disabled, ...rest } = this.props;
    return (
      <>
        {trigger({
          onClick: this.handleTriggerClick,
          disabled,
        })}
        {modal ? (
          modal({
            ...rest,
            show: this.state.shown,
            onHide: this.handleModalHide,
          })
        ) : (
          <Modal show={this.state.shown} onHide={this.handleModalHide} children={children} />
        )}
      </>
    );
  }
}
